import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SearchBar } from '~/components/forms/search-bar';

export interface SpreadsheetToolbarProps {
  editable: boolean;
  onAddRow: () => void;
  onSearch: (search: string) => void;
  search: string;
}

export const SpreadsheetToolbar = ({
  editable,
  onAddRow,
  onSearch,
  search,
}: SpreadsheetToolbarProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        pb: 2,
      }}
    >
      <SearchBar
        placeholder={t('pages.data_sources.edit.search_placeholder')}
        search={search}
        onChange={onSearch}
      />
      <Box>
        {editable && (
          <Button onClick={onAddRow} variant="outlined">
            {t('pages.data_sources.spreadsheet_toolbar.add_row')}
          </Button>
        )}
      </Box>
    </Box>
  );
};
